// src/pages/NotFound.js
import React from "react";

export default function NotFound() {
  return <h1>صفحه پیدا نشد (404)</h1>;
}
